import { type JSX } from 'react';
import { Link } from 'react-router';
import { useBrand } from '@common/brand/BrandContext';
import { serviceWelt, userManagement } from '@common/components/PageHeader/constants';
import LogoStiebelEltron from '@common/components/PageHeader/LogoStiebelEltron';
import LogoTecalor from '@common/components/PageHeader/LogoTecalor';
import { useDarkModeContext } from '@common/containers/ApplicationContext';
import '@common/styles/components/pageHeader.pcss';

export interface PageHeaderProps {
  leftAction?: JSX.Element;
  rightAction?: JSX.Element;
  logoDisabled?: boolean;
  showBetaBadge?: boolean;
}

function PageHeader({
  leftAction,
  rightAction,
  logoDisabled,
  showBetaBadge,
}: Readonly<PageHeaderProps>) {
  const { isDarkMode } = useDarkModeContext();
  const { isTecalor: isTecalorBrand, brandConfig } = useBrand();

  const linkTitle = (() => {
    if (isTecalorBrand) { return brandConfig.headerTitle; }
    if (APP_TYPE === 'um') { return userManagement; }
    return serviceWelt;
  })();

  const brandLogo = isTecalorBrand
    ? <LogoTecalor />
    : <LogoStiebelEltron color={isDarkMode ? 'var(--color-white)' : 'var(--color-brand-main)'} />;

  const logo = showBetaBadge
    ? (
      <span className="page-header__logo-wrapper">
        {brandLogo}
        <span className="page-header__beta-badge" aria-hidden="true">
          BETA
        </span>
      </span>
    )
    : brandLogo;

  return (
    <header className="page-header">
      <div className="container">
        <div className="page-header__wrapper align-items-center">
          {APP_TYPE === 'alexa'
            ? <span className="page-header__logo hide-screen-small" />
            : logoDisabled
            ? (
              <span
                title={linkTitle}
                className="ph-no-capture page-header__link hide-screen-small align-items-center"
              >
                {logo}
              </span>
            )
            : (
              <Link
                to="/"
                reloadDocument
                title={linkTitle}
                className="ph-no-capture page-header__link hide-screen-small align-items-center"
              >
                {logo}
              </Link>
            )}
          {leftAction}
          {!!rightAction && (
            <div className="page-header__nav">
              {rightAction}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default PageHeader;
